import React from 'react';
// import Slider from "./Slider";
// import Quote from './Quote';

import { Features1, soon1 } from '../components/Data/Arabic';
import { Features2, soon2 } from '../components/Data/English';


const Features = ({lang}) => {

    const Data = lang ? Features2 : Features1;

    return (

        <div className="features xl:px-16 lg:px-14 w-full sm:px-0 relative " id='paths'>
            <div className="section ">
                <div className="section-container mx-auto sm:p-0 ">
                    <div className="mx-auto text-center relative flex justify-center">
                        <h2 className="xl:text-5xl lg:text-4xl  sm:text-3xl py-8 mb-8 text-center font-black">المسارات</h2>
                        <span className="bg-orange w-28 lg:w-28 sm:w-20 h-1 absolute rounded mt-24 lg:mt-28"></span>
                    </div>

                    <div className="design-box  xl:max-w-[1380px] xl:mx-auto
                  w-11/12 lg:w-[96%] flex justify-between items-center my-20 mx-auto
                rounded-3xl border-2 border-lightBlack border-t-[25px]
                border-t-orange gap-5 sm:gap-0 sm:w-11/12 py-20 
                 md:py-14 md:px-2 px-7 sm:p-0 shadow-lg xl:py-32 xl:px-8 lg:py-16 lg:px-6 md:flex-row
                 sm:flex-col sm:py-8
                 ">

                    <div className="img-box w-2/4 lg:w-[48%]  md:w-[45%] sm:w-[90%] sm:mx-auto  mr-5 md:mr-2 lg:mr-1
                       rounded-3xl sm:rounded-2xl border-2  xl:max-w-[43%]
                    border-lightBlack flex justify-center items-center">
                        <img className='w-full rounded-3xl sm:rounded-2xl' src="assets/images/paths/sf.svg" alt="path-pic" />
                    </div>
                    
                    <div className="content-box xl:w-[48%] lg:w-[47%] md:w-[55%] sm:w-[80%] sm:mx-auto sm:text-center md:text-right mr-10 xl:mr-10 lg:mr-3 md:mr-8 md:pl-2 sm:m-0 mb-5 xl:px-8">      
                            {
                                Data.map(item => (
                                    <div key={item.id}>
                                        <h2 className={lang ? 'xl:text-4xl lg:text-3xl md:text-2xl sm:text-lg py-8 mb-2 xl:pb-12 lg:py-8 xl:-mt-[1rem]  lg:mb-2 md:py-4 md:mb-2 sm:-mb-1 font-black lg:text-left sm:text-center'
                                         : 'xl:text-4xl lg:text-3xl md:text-2xl sm:text-lg py-8 mb-2 xl:pb-12 lg:py-8 xl:-mt-[1rem]  lg:mb-2 md:py-4 md:mb-2 sm:-mb-1 font-black'}>
                                            {item.title}
                                        </h2>
                                        <p className={lang ? `lg:font-black font-black xl:pr-16 xl:leading-loose lg:pr-2 lg:leading-loose md:leading-8 
                                            lg:text-xl md:text-lg sm:text-[15px] sm:leading-7 sm:font-normal -mt-4 md:pr-7 sm:pl-3 xl:mb-5 text-left lg:text-left sm:text-center`
                                            :
                                        `lg:font-black font-black xl:pl-16 xl:leading-loose lg:pl-2 lg:leading-loose md:leading-8 
                                        lg:text-xl md:text-lg sm:text-[15px] sm:leading-7 sm:font-normal -mt-4 md:pl-7 sm:pl-3 xl:mb-5`}>
                                            {item.text}
                                        </p>
                                    </div>
                                ))
                            }

                        <div className="info flex justify-evenly sm:justify-around lg:w-full sm:w-full items-center xl:-ml-2 xl:mt-3  lg:-ml-1 lg:mr-1 lg:mt-4 xl:py-2 xl:px-0 md:pl-3 md:-mr-3 sm:mt-5">
                            <div className='border-l-4 lg:text-[1rem] xl:text-xl lg:font-black lg:leading-8 xl:leading-10 lg:border-l-4 xl:px-5 lg:pr-0 lg:pl-4  md:border-l-3  sm:border-l-2 px-4 md:pl-3 sm:pl-4 leading-8
                             md:leading-5 text-center md:text-sm sm:text-[12px] sm:font-normal sm:leading-4 '>
                                    <i className="fas fa-graduation-cap"></i>
                                    <p>الفوج القادم </p>
                                    <p> حزيران - تموز</p>
                                </div>
                                <div className='border-l-4 lg:border-l-4  lg:text-lg xl:text-xl lg:font-black lg:leading-8 xl:leading-10  md:border-l-3 sm:border-l-2 xl:px-5 lg:px-3.5 md:px-2 sm:px-2 sm:-ml-1 leading-8 
                            md:leading-5 text-center md:text-sm sm:text-[12px] sm:leading-4  sm:font-normal'>
                                    <i className="fas fa-hourglass-half"></i>
                                    <p>مدة التخصص</p>
                                    <p> 2 - 3 أشهر</p>
                                </div>
                                <div className='xl:px-5 lg:pr-3 lg:pl-0 lg:text-lg xl:text-xl lg:font-black lg:leading-8 xl:leading-10  md:px-2 sm:pl-1 sm:pr-2 md:leading-5 sm:leading-4 
                            text-center md:text-sm sm:text-[12px] sm:font-normal'>
                                    <i className="far fa-clock"></i>
                                    <p>مواعيد الافتتاح </p>
                                    <p>كل 3 أشهر</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p className="section-text  font-black py-16 leading-loose  
                text-4xl sm:text-3xl -mt-4 text-center">{lang ? soon2 : soon1}</p>
                </div>
                {/* <Slider /> */}
            </div>
            {/*         
        <Quote text={`نحو عالم يتفوق فيه شبابنا بمهاراتهم ولا يكون أبعد طموحهم
          وظيفة لا تعيلهم اذا مرضوا`}/> */}
        </div>
    )
}

export default Features;
